import { TransformInt } from '../../../shared';
import { TransformDate } from '../../../shared/decorators/transform-date.decorator';

/**
 * Lease billable events request DTO
 */
export class LeaseBillableEventsRequest {
	leasedBy!: string;
	@TransformDate()
	leasedUntil!: Date;
	@TransformInt()
	batch!: number;
	@TransformInt()
	maxRetryCount!: number;
}
